import { render, staticRenderFns } from "./RegistrationSignIn.vue?vue&type=template&id=5c3a4d18"
import script from "./RegistrationSignIn.vue?vue&type=script&lang=js"
export * from "./RegistrationSignIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports